module.exports = __webpack_public_path__ + "static/media/linkedin.037b83d4.svg";